import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, formData) =>
  await AxiosConfig.create('post', url).call(formData).getResponseData();

function useDashboardOrder(formData) {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    '/dashboard-order/datas',
    (url) => fetcher(url, formData),
    {
      revalidateOnFocus: false, // Désactiver la revalidation au focus
      revalidateOnReconnect: false, // Optionnel: désactiver la revalidation à la reconnexion
      dedupingInterval: 5000, // Optionnel: ajouter un intervalle de déduplication pour éviter les requêtes trop fréquentes
    }
  );

  return {
    data: {
      orders: data?.data?.orders,
      orderRefs: data?.data?.orderRefs,
      paymentStatus: data?.data?.paymentStatus,
      totalCount: data?.data?.totalCount,
    },
    res: {
      status: data?.code || _error?.response?.status,
      statusText: data?.message || _error?.response?.statusText,
    },
    isLoading,
    isValidating,
    mutate: mutate,
  };
}

export default useDashboardOrder;
